import "./styles.css";
import React, { useEffect, useState } from "react";
import { IonCol, IonButton, IonIcon } from "@ionic/react";
import { createOutline } from "ionicons/icons";
import { UserBidStatus } from "../AuctionItems/Index";
import Text from "../CommonStyles/Text";
import { useSelector } from "react-redux";
import { AppState } from "../../redux/store";

export const CurrentBid = ({
  currentBid,
  status,
  quantity,
  numOfBids,
  minimumBidIncrease,
  isPriceless,
  fairMarketValue,
  onMaxBid,
  accountisautobid,
  accountautobidamount,
  accountautobidincrement,
}: {
  currentBid: number;
  status: UserBidStatus;
  quantity: number;
  numOfBids: number;
  minimumBidIncrease: number;
  isPriceless: boolean;
  fairMarketValue: number;
  onMaxBid: any;
  accountisautobid: boolean;
  accountautobidamount: number;
  accountautobidincrement: number;
}) => {
  const [bidUpdate, setBidUpdate] = useState(false);
  const auctionItemDetailsState = useSelector((state: AppState) => state.auctionItemDetails);

  useEffect(() => {
    setBidUpdate(true);
    setTimeout(() => setBidUpdate(false), 1000);
  }, [auctionItemDetailsState.currentbid]);

  const checkAccountStatus = () =>
    accountisautobid && status !== "winner" && status === "highBidder";

  return (
    <>
      <IonCol size="12" style={{ padding: 0 }}>
        <div className="as-bidrow">
          <div>
            <div className="as-bidrow-lab">Current bid</div>
            <div className={`as-bidrow-amt${bidUpdate ? ' updated' : ''}`}>
              {quantity > 0 ? `$${currentBid}` : 'SOLD OUT'}
            </div>
            {quantity > 0 && (
              <div style={{ fontSize: 12, color: '#666' }}>{numOfBids} Bids</div>
            )}
          </div>
          <div className="as-bidrow-r">
            {isPriceless && (
              <>
                <div className="as-bidrow-amt" style={{ fontSize: 20 }}>Priceless</div>
                <div className="as-bidrow-lab">Fair Market Value</div>
              </>
            )}
            {!isPriceless && fairMarketValue > 0 && (
              <>
                <div className="as-bidrow-amt" style={{ fontSize: 20 }}>${fairMarketValue}</div>
                <div className="as-bidrow-lab">Fair Market Value</div>
              </>
            )}
            {!isPriceless && fairMarketValue <= 0 && (
              <>
                <div className="as-bidrow-amt" style={{ fontSize: 20 }}>${minimumBidIncrease}</div>
                <div className="as-bidrow-lab">Min bid increase</div>
              </>
            )}
          </div>
        </div>
        {checkAccountStatus() && (
          <IonButton id="notification-button" ion-button fill="clear" onClick={onMaxBid}>
            <Text fontWeight="300" fontSize="16px">
              Your max bid: ${accountautobidamount}
              <IonIcon icon={createOutline} slot="icon-only" color="dark" style={{ width: '1.5rem', height: '1rem' }} />
            </Text>
          </IonButton>
        )}
      </IonCol>
    </>
  );
};
